function openOfferDrawer() {
    document.querySelector("size-guide-drawer").classList.add("active");
    console.log('ajbdjhdbjadbha');
    document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
    const cc = document.querySelector('.click-capture');
    cc.setAttribute('initialized', '');
}

function closeOfferDrawer() {
    document.getElementById("offerDrawer").classList.remove("open");
}

